<div class="header">
  <h3>{{'DOCUMENT-REQUEST.TITLE' | translate}}</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="search()" (clear)="clear()"></app-filter-header>
  <div class="row row-eq-height">
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown class="dv-dropdown"
            selectId="room-type"
            [options]="roomChoices"
            [(ngModel)]="selectedRoomType"
            placeholder="{{ 'FILTER.ROOM-TYPE' | translate }}">
        </p-dropdown>
        <label for="room-type">{{ 'FILTER.ROOM-TYPE' | translate }}</label>
      </div>
    </div>
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown class="dv-dropdown"
            selectId="status"
            [options]="statusChoices"
            [(ngModel)]="selectedStatus"
            placeholder="{{ 'FILTER.STATUS' | translate }}">
        </p-dropdown>
        <label for="status">{{ 'FILTER.STATUS' | translate }}</label>
      </div>
    </div>
    <div class="col-md-4">
      <div class="dropdown" #dd="ngbDropdown" ngbDropdown placement="bottom-right" autoClose="outside">
        <div class="form-label-group">
          <input #ddi
              class="form-control"
              type="text"
              id="calendarDropdown"
              [value]="dateRange"
              ngbDropdownToggle
              placeholder="{{'FILTER.REQUEST-DATE' | translate}}"
              readonly>
          <label for="calendarDropdown">{{'FILTER.REQUEST-DATE' | translate}}</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.SINCE' | translate}}</div>
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.UNTIL' | translate}}</div>
          </div>
          <div (click)="$event.stopPropagation();">
            <p-calendar [(ngModel)]="startDate"
                [defaultDate]="startDate"
                dateFormat="dd/mm/yy"
                [maxDate]="maxDate"
                readonlyInput="true"
                [showIcon]="true"
                [monthNavigator]="true"
                [yearNavigator]="true"
                [yearRange]="yearRange"
                (onSelect)="setMinDate()"
                [inline]="true"
                [locale]="calendarLocale">
            </p-calendar>
            <p-calendar [(ngModel)]="endDate"
                [defaultDate]="startDate"
                dateFormat="dd/mm/yy"
                [minDate]="minDate"
                readonlyInput="true"
                [showIcon]="true"
                [monthNavigator]="true"
                [yearNavigator]="true"
                [yearRange]="yearRange"
                (onSelect)="setMaxDate(); dd.close()"
                [inline]="true"
                [locale]="calendarLocale">
            </p-calendar>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row row-eq-height m-t-10">
    <div class="col-md-4">
      <div class="form-label-group">
        <input class="form-control"
            type="text"
            id="request-no"
            [(ngModel)]="requestNo"
            placeholder="{{'FILTER.REQUEST-NO' | translate}}">
        <label for="request-no">{{'FILTER.REQUEST-NO' | translate}}</label>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-label-group">
        <input class="form-control"
            type="text"
            id="abb-no"
            [(ngModel)]="abbNo"
            placeholder="{{'FILTER.ABB-NO' | translate}}">
        <label for="abb-no">{{'FILTER.ABB-NO' | translate}}</label>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-label-group">
        <input class="form-control"
            type="text"
            id="confirmation-no"
            [(ngModel)]="confirmationNo"
            placeholder="{{'FILTER.CONFIRMATION-NO' | translate}}">
        <label for="confirmation-no">{{'FILTER.CONFIRMATION-NO' | translate}}</label>
      </div>
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <app-custom-pagination *ngIf="!loading && totalItems !== 0"
      [(currentPage)]="currentPage"
      [(itemsPerPage)]="itemsPerPage"
      [totalItems]="totalItems"
      [maxSize]="5"
      (pageChange)="pageChanged()"
      (optionChange)="optionChange()">
  </app-custom-pagination>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
  </div>

  <div class="row m-t-20" *ngIf="totalItems === 0 && !loading">
    <div class="col-12 text-center">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
    </div>
  </div>

  <div class="m-t-20 text-center">
    <p-table *ngIf="totalItems !== 0"
        [loading]="loading"
        tableStyleClass="table"
        [tableStyle]="{'min-width': '1280px'}"
        [value]="tableData"
        [autoLayout]="true">
      <ng-template pTemplate="header">
        <tr>
          <th>{{'COMMON.TABLE.ORDER' | translate}}</th>
          <th>{{'TABLE.REQUEST-NO' | translate}}</th>
          <th>{{'TABLE.REQUEST-DATE' | translate}}</th>
          <th>{{'TABLE.ROOM-TYPE' | translate}}</th>
          <th>{{'TABLE.CUSTOMER-NAME' | translate}}</th>
          <th>{{'TABLE.ABB-NO' | translate}}</th>
          <th>{{'TABLE.CONFIRMATION-NO' | translate}}</th>
          <th>{{'TABLE.STATUS' | translate}}</th>
          <th>{{'TABLE.NOTE' | translate}}</th>
          <th>{{'TABLE.DETAIL' | translate}}</th>
          <th style="width: 180px;">{{'TABLE.ACTION' | translate}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td>{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
          <td>{{data.request_no}}</td>
          <td>{{data.request_date}}</td>
          <td>{{data.room_type_display}}</td>
          <td>{{data.buyer_name}}</td>
          <td>{{data.abb_no || '-'}}</td>
          <td>{{data.confirmation_no || '-'}}</td>
          <td>{{data.status_display}}</td>
          <td *ngIf="data.status === 'done'">
            {{ 'TABLE.ACCEPTED-BY' | translate }} {{ data.actor || '-' }}
          </td>
          <td *ngIf="data.status === 'cancelled'">
            {{ 'TABLE.CANCELLED-BY' | translate }} {{ data.actor || '-' }}
          </td>
          <td *ngIf="data.status === 'pending'">
            -
          </td>
          <td>
            <i class="fas fa-eye pointer" title="View details" (click)="openDocumentRequestDetail(documentRequestContent, data.id)"></i>
          </td>
          <td>
            <button class="btn btn-custom-cancel"
                *ngIf="data.status !== 'cancelled'"
                [disabled]="data.status !== 'pending'"
                (click)="openConfirmationModal(confirmationContent, data.id, 'cancel')">
              {{ 'COMMON.CANCEL' | translate }}
            </button>
            <button class="btn btn-custom-confirm p-y-4 p-x-8"
                *ngIf="data.status === 'cancelled'"
                (click)="openConfirmationModal(confirmationContent, data.id, 'restore')">
              {{ 'COMMON.RESTORE' | translate }}
            </button>
            <button class="btn btn-custom-delete"
                [disabled]="data.status !== 'cancelled'"
                (click)="openConfirmationModal(confirmationContent, data.id, 'delete')">
              {{ 'COMMON.DELETE' | translate }}
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<ng-template #successContent>
  <div class="modal-body text-center p-y-24">
    <h5 class="m-0">{{ 'COMMON.COMPLETE' | translate }} !</h5>
  </div>
  <div class="modal-footer p-y-10">
    <button class="btn btn-custom-confirm" (click)="closeModal(true)">
      {{ 'COMMON.CLOSE' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #confirmationContent>
  <div class="modal-header">
    <h5 class="modal-title">{{ 'DOCUMENT-REQUEST.TITLE' | translate }}</h5>
  </div>
  <div class="modal-body p-y-24">
    <h6 class="m-0">{{ confirmMsg }}</h6>
  </div>
  <div class="modal-footer p-y-10">
    <button class="btn btn-custom-confirm" (click)="confirmAction()">
      <i class="fa fa-spinner fa-spin" *ngIf="processing"></i>
      {{ 'COMMON.OK' | translate }}
    </button>
    <button class="btn btn-custom-delete" (click)="closeModal()">
      {{ 'COMMON.CLOSE' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #documentRequestContent>
  <div class="modal-header">
    <h5 class="modal-title">{{ 'DOCUMENT-REQUEST.TITLE' | translate }}</h5>
  </div>
  <div class="modal-body">
    <div class="row align-items-center">
      <div class="col-md-2">
        {{'NORMAL.CUS-NAME'|translate}}
      </div>
      <div class="col-md-4">
        <input class="form-control"
            type="text"
            id="buyer-name"
            [(ngModel)]="documentRequest.buyer_name"
            readonly>
      </div>
      <div class="col-md-2">
        {{'Tax ID'|translate}}
      </div>
      <div class="col-md-4">
        <input class="form-control"
            type="text"
            id="tax-id"
            [(ngModel)]="documentRequest.tax_id"
            readonly>
      </div>
    </div>
    <div class="row align-items-center m-t-10">
      <div class="col-md-2">
        {{'TABLE.BRANCH-CODE'|translate}}
      </div>
      <div class="col-md-4">
        <input class="form-control"
            type="text"
            id="branch-code"
            [(ngModel)]="documentRequest.branch_code"
            readonly>
      </div>
      <div class="col-md-2">
        {{'TABLE.BRANCH-NAME'|translate}}
      </div>
      <div class="col-md-4">
        <input class="form-control"
            type="text"
            id="branch-name"
            [(ngModel)]="documentRequest.branch_name"
            readonly>
      </div>
    </div>
    <div class="row align-items-center m-t-10">
      <div class="col-md-2">
        {{'DOCUMENT-REQUEST.ADDRESS'|translate}}
      </div>
      <div class="col-md-4">
        <textarea class="form-control"
            rows="2"
            id="address"
            [(ngModel)]="documentRequest.address"
            readonly>
        </textarea>
      </div>
      <div class="col-md-6">
        <div class="row align-items-center">
          <div class="col-md-4">
            {{'DATA.DELIVERY-POSTALCODE'|translate}}
          </div>
          <div class="col-md-8">
            <input class="form-control"
                type="text"
                id="postal-code"
                [(ngModel)]="documentRequest.postal_code"
                readonly>
          </div>
        </div>
        <div class="row align-items-center m-t-10">
          <div class="col-md-4">
            {{'DATA.COUNTRY'|translate}}
          </div>
          <div class="col-md-8">
            <input class="form-control"
                type="text"
                id="country"
                [(ngModel)]="currentLang === 'en' ? documentRequest.country_display : documentRequest.country_display_th"
                readonly>
          </div>
        </div>
      </div>
    </div>
    <div class="row align-items-center m-t-10">
      <div class="col-md-2">
        {{'EMAIL-DASHBOARD.EMAIL'|translate}}
      </div>
      <div class="col-md-4">
        <input class="form-control"
            type="text"
            id="email"
            [(ngModel)]="documentRequest.email"
            readonly>
      </div>
      <div class="col-md-2">
        {{'EMAIL-DASHBOARD.CC-EMAIL'|translate}}
      </div>
      <div class="col-md-4">
        <input class="form-control"
            type="text"
            id="cc-email"
            [(ngModel)]="documentRequest.cc_email"
            readonly>
      </div>
    </div>
    <div class="row align-items-center m-t-10">
      <div class="col-md-2 p-r-0">
        {{ 'DOCUMENT-REQUEST.PHONE-NUMBER' | translate }}
      </div>
      <div class="col-md-10">
        <input class="form-control"
            type="text"
            id="phone-number"
            [(ngModel)]="documentRequest.phone_number"
            readonly>
      </div>
    </div>
    <div class="row align-items-center m-t-10">
      <div class="col-md-2">
        {{ 'TABLE.ROOM-TYPE' | translate }}
      </div>
      <div class="col-md-10">
        <input class="form-control"
            type="text"
            id="room-type"
            [(ngModel)]="documentRequest.room_type_display"
            readonly>
      </div>
    </div>
    <div class="row align-items-center m-t-10">
      <div class="col-md-2">
        {{ 'TABLE.ABB-NO' | translate }}
      </div>
      <div class="col-md-4">
        <input class="form-control"
            type="text"
            id="abb-no"
            [(ngModel)]="documentRequest.abb_no"
            readonly>
      </div>
      <div class="col-md-2">
        {{ 'TABLE.CONFIRMATION-NO' | translate }}
      </div>
      <div class="col-md-4">
        <input class="form-control"
            type="text"
            id="confirmation-no"
            [(ngModel)]="documentRequest.confirmation_no"
            readonly>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button"
        class="btn btn-custom-confirm"
        (click)="closeModal()">{{ 'COMMON.CLOSE' | translate}}</button>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-request/document-request.component.html